export default "__VITE_ASSET__Bhtq8war__"